"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (d) {
  return d;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-stockcharts/lib/utils/identity.js
// module id = 92
// module chunks = 0